import { CropTableProps } from 'utils/types';
import { cn } from 'utils/cn';
import { unMaskInputValue } from 'utils/helpers';
import { formatSwissNumber } from 'utils/formatNumber';

import { Cell } from './Cell';
import { ActionButtons } from './ActionButtons';

import { pdfColumnWidth } from '.';

export const TableRow = ({
  data,
  isPDF,
  disabled,
  tableDataLength,
  onDuplicate,
  onEdit,
  onDelete,
}: {
  data: CropTableProps;
  isPDF?: boolean;
  disabled: boolean;
  tableDataLength: number;
  onDuplicate: (id: number) => void;
  onEdit: (value: CropTableProps) => void;
  onDelete: (id: number) => void;
}) => (
  <div
    className={cn(
      'flex px-4 pt-3 pb-3 border-b bg-white divide-x divide-transparent text-sm',
      { 'text-xs': isPDF },
    )}
  >
    <Cell isPDF={isPDF} pdfWidth={pdfColumnWidth['1']} defaultWidth="w-[160px]">
      {data?.name}
    </Cell>

    <div className={cn('flex px-0.5', { [pdfColumnWidth['2']]: isPDF })}>
      <Cell
        isPDF={isPDF}
        pdfWidth="w-1/2"
        defaultWidth="w-[80px]"
        className="flex justify-center bg-primitiveBlue"
      >
        {unMaskInputValue(String(data?.yield ?? ''))}
      </Cell>
      <Cell
        isPDF={isPDF}
        pdfWidth="w-1/2"
        defaultWidth="w-[80px]"
        className="flex justify-center bg-primitiveBlue"
      >
        {unMaskInputValue(String(data?.price))}
      </Cell>
    </div>

    <div className={cn('flex px-0.5', { [pdfColumnWidth['3']]: isPDF })}>
      <Cell isPDF={isPDF} pdfWidth="w-1/4" defaultWidth="w-[100px]">
        {unMaskInputValue((+data?.phIfNoLim).toFixed(2))}
      </Cell>
      <Cell isPDF={isPDF} pdfWidth="w-2/4" defaultWidth="w-[100px]">
        {data?.limiting}
      </Cell>
      <Cell isPDF={isPDF} pdfWidth="w-1/4" defaultWidth="w-[100px]">
        {unMaskInputValue(String(data?.expectPh))}
      </Cell>
    </div>

    <div className={cn('flex px-0.5', { [pdfColumnWidth['2']]: isPDF })}>
      <Cell isPDF={isPDF} pdfWidth="w-1/2" defaultWidth="w-[60px]">
        {unMaskInputValue(String(data?.yieldPercent))}
      </Cell>
      <Cell isPDF={isPDF} pdfWidth="w-1/2" defaultWidth="w-[60px]">
        {data?.yieldPrice}
      </Cell>
    </div>

    <div className={cn('flex px-0.5', { [pdfColumnWidth['3']]: isPDF })}>
      <Cell isPDF={isPDF} pdfWidth="w-1/3" defaultWidth="w-[100px]">
        {data.n}
      </Cell>
      <Cell isPDF={isPDF} pdfWidth="w-1/3" defaultWidth="w-[100px]">
        {data.p}
      </Cell>
      <Cell isPDF={isPDF} pdfWidth="w-1/3" defaultWidth="w-[100px]">
        {data.k}
      </Cell>
    </div>

    <Cell isPDF={isPDF} pdfWidth={pdfColumnWidth['1']} defaultWidth="w-[100px]">
      {formatSwissNumber(Math.round(Number(data?.npkGains)))}
    </Cell>

    <Cell isPDF={isPDF} pdfWidth={pdfColumnWidth['1']} defaultWidth="w-[100px]">
      {formatSwissNumber(Math.round(Number(data.monps)))}
    </Cell>

    <Cell isPDF={isPDF} pdfWidth={pdfColumnWidth['1']} defaultWidth="w-[100px]">
      {formatSwissNumber(Math.round(Number(data.total)))}
    </Cell>

    {!isPDF && (
      <ActionButtons
        data={data}
        disabled={disabled}
        tableDataLength={tableDataLength}
        onDuplicate={onDuplicate}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    )}
  </div>
);
